<template>
  <div class="shoplist">
      <div class="shopitem" v-for="item in 5">
          <img src="../../../assets/icon6.png" alt="">
          <span>10+</span>
          <p>国企客户</p>
      </div>
  </div>
</template>

<script>

export default {
  name: 'shoplist',
  components:{

  }
}
</script>

<style lang="less">
    .shoplist{
      width: 100%;
      height: 150px;
      padding: 0 200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
        .shopitem{
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          img{
            width: 60px;
            height: 60px;
            margin-bottom: 20px;
          }
          span{
              font-weight: 500;
              font-size: 16px;
              line-height: 34px;
              color: #292929;
          }
          p{
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #999999;
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/shop/components/shoplist.vue